
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","d":"M-271-823h1400V393H-271z"}}),_c('path',{attrs:{"d":"M8 16A8 8 0 118 0a8 8 0 010 16z","fill":"#FF5350"}}),_c('path',{attrs:{"d":"M6.457 5.429L8 6.972l1.543-1.543a.727.727 0 011.028 1.028L9.028 8l1.543 1.543a.727.727 0 11-1.028 1.028L8 9.028 6.457 10.57A.727.727 0 115.43 9.543L6.972 8 5.429 6.457A.727.727 0 016.457 5.43z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    